import { StorageService } from './../../../services/system/storage.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { saveAs } from 'file-saver';
import { Message } from 'primeng/components/common/api';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { SelectItem } from "primeng/components/common/selectitem";
import { MenuItem, TreeNode } from 'primeng/primeng';
import { CreateFolderModel } from '../../../models/inModels/CreateFolderModel';
import { NotificationContentType } from "../../../models/inModels/MessageModel";
import {
	AddDocumentAuthor,
	AddObjectiveModel,
	CoursePath,
	DescribeFileModel,
	LearningCourse,
	MoveDirectoryModel,
	RenameDirectoryModel,
	RenameFileModel,
	ReorderDirectoryFilesModel,
	TagFileModel,
	UpdateDirectoryMetaModel,
	UpdateInterestsModel,
	UpdatePlansModel,
	UploadLinkModel
} from '../../../models/inModels/TagFileModel';
import { IFile } from '../../../models/outModels/File';
import { SubscriptionPlanService as SubscriptionService } from '../../../services/subscription.service';
import { UserService } from "../../../services/user/user.service";

@Component({
	selector: 'app-upload',
	templateUrl: './upload.component.html',
	styleUrls: ['./upload.component.css']
})

export class UploadComponent implements OnInit {
	loading = false;
	downloading = false;
	uploading = false;
	uploadingLogo = false;
	uploadingCover = false;
	uploadingfeatured = false;
	tags = false;
	desc = false;
	showMoveFile = false;
	showRenameFile = false;
	showRenameFolder = false;
	showUpdateFolder = false;
	showObjectives = false;
	showCoverUploader = false;
	interest = false;
	folder: CreateFolderModel;
	folders: TreeNode[];
	files: IFile[];
	selectedFile: IFile;
	selectedFolder: any;
	selectedMoveFolder: TreeNode;
	tag: TagFileModel;
	renameFileModel: RenameFileModel;
	renameFolderModel: RenameDirectoryModel;
	updateFolderModel: UpdateDirectoryMetaModel;
	addObjectiveModel: AddObjectiveModel;
	description: DescribeFileModel;
	author: AddDocumentAuthor;
	link: UploadLinkModel;
	error: Message[];
	items: MenuItem[];
	folderLogo;
	folderIcon;
	objectives: string[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	interestModel: UpdateInterestsModel;
	interests: SelectItem[];
	// Uplaod images for the documents
	coverImageId: string;
	featuredImageIds: string[] = [];

	isDesigned: boolean;
	//change plans for file
	showPlans = false;
	planModel: UpdatePlansModel;

	learningCourses: SelectItem[] = [];
	showLearningCourses = false;
	showCoursePath = false;
	showAddCourseDialog = false;
	showAddCoursePathDialog = false;
	newCourse: LearningCourse = {
		CourseName: '',
		CourseImageId: null,
		Description: '',
		LearningOutcomes: '',
		TargetAudience: '',
		Speakers: '',
		CoursePathId: 0 || undefined,  // <-- set to undefined initially
		Tags: ''
	};




	newCoursePath: CoursePath = {
		Id: undefined,
		Name: '',
		Description: '',
		PathOrder: 1,
		CoverId: null,
		Published: false,
		CourseId: null,
		CreatedByUserId: null,
		DateCreatedUtc: null,
		DateUpdatedUtc: null
	};


	learningCoursesInfo: any[] = [];
	showEditCourseDialog = false;
	showEditCoursePathDialog = false;

	editCourseData: any = {};
	editCoursePathData: any = {};

	showAttachmentDialog = false;
	selectedFileForAttachment: any = null;
	attachmentFileId: string = null;
	coursePaths: CoursePath[] = [];
	selectedInterests: string[] = [];
	selectedCourse: any = null;
	courseTag: any = { Name: '' };


	constructor(
		public storageService: StorageService,
		private confirmationService: ConfirmationService,
		public userService: UserService,
		private subscriptionService: SubscriptionService,
	) {
		this.loading = true;
	}

	ngOnInit() {
		this.folder = new CreateFolderModel();
		this.tag = new TagFileModel();
		this.renameFileModel = new RenameFileModel();
		this.renameFolderModel = new RenameDirectoryModel();
		this.description = new DescribeFileModel();
		this.link = new UploadLinkModel();
		this.updateFolderModel = new UpdateDirectoryMetaModel();
		this.selectedFolder = {
			label: '',
			color: '',
			description: '',
			logo: ''
		};
		this.interestModel = new UpdateInterestsModel();
		this.loadFolders();
		this.learningCourseDropdown();
		this.loadCoursePath();
	}

	loadCoursePath() {
		this.storageService.getCoursePaths().subscribe({
			next: (data) => {
				this.coursePaths = data;
			},
			error: (err) => {
				console.error('Error fetching course paths', err);
			}
		});
	}

	loadFolders() {
		this.storageService.getRootDirectory(true).then(
			folders => {
				this.loading = false;
				this.folders = folders;
			},
			error => {
				console.log(error);
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	loadNode(event) {
		if (event.node) {
			this.loading = true;
			this.storageService.getDirectory(event.node.data, true).then(nodes => {
				this.loading = false;
				event.node.children = nodes.Children;
			},
				error => {
					console.log(error);
					this.loading = false;
					this.error = [];
					this.error.push({ severity: 'error', summary: 'Error', detail: error });
				});

		}
	}

	loadFiles(event) {
		this.showLearningCourses = false;
		this.showCoursePath = false;
		this.showEditCourseDialog = false;
		if (event.node) {
			this.getFiles(event.node.data);
		}
	}

	moveToRoot() {
		this.confirmationService.confirm({
			message: `Are you sure you want to move the folder to the Home Page?`,
			header: 'Move Confirmation',
			icon: 'fa fa-files-o',
			accept: () => {
				this.loading = true;
				var model = new MoveDirectoryModel();
				model.Id = this.selectedFolder.data;
				model.ParentId = "1";
				this.storageService.moveDirectory(model).then(
					result => {
						this.loadFolders();
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			},
			reject: () => {

			}
		});
	}

	moveFolder(event) {
		this.confirmationService.confirm({
			message: `Are you sure you want to move the folder <strong>${event.dragNode.label}</strong> to <strong>${event.dropNode.label}</strong>?`,
			header: 'Move Confirmation',
			icon: 'fa fa-files-o',
			accept: () => {
				this.loading = true;
				var model = new MoveDirectoryModel();
				model.Id = event.dragNode.data;
				model.ParentId = event.dropNode.data;
				this.storageService.moveDirectory(model).then(
					result => {
						this.loading = false;
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			},
			reject: () => {
				console.log(event);
				event.node = event.dragNode.parent;
				this.loadNode(event);
			}
		});
	}

	getFiles(directoryId: number) {
		this.loading = true;
		this.storageService.getDirectoryContent(directoryId).then(files => {
			this.loading = false;
			this.files = files;
		},
			error => {
				console.log(error);
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	create(): void {
		this.loading = true;
		this.folder.ParentId = this.selectedFolder.data;
		this.storageService.createDirectory(this.folder).then(
			result => {
				this.loadFolders();
				this.folder = new CreateFolderModel();
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	renameFolder(): void {
		this.loading = true;
		this.storageService.renameDirectory(this.renameFolderModel).then(
			result => {
				this.loading = false;
				this.selectedFolder.label = this.renameFolderModel.Name;
				this.showRenameFolder = false;
			},
			error => {
				this.showRenameFolder = false;
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewRenameFolder(): void {
		this.renameFolderModel.Id = this.selectedFolder.data;
		this.renameFolderModel.Name = this.selectedFolder.label;
		this.showRenameFolder = true;
	}

	updateFolder(): void {
		this.loading = true;
		this.storageService.updateDirectory(this.updateFolderModel).then(
			result => {
				this.loading = false;
				this.selectedFolder.logo = result.logo;
				this.selectedFolder.logoId = result.logoId;
				this.selectedFolder.color = result.color;
				this.selectedFolder.heading = result.heading;
				this.selectedFolder.structured = result.Structured;
				this.selectedFolder.iconId = result.iconId;
				this.selectedFolder.icon = result.icon;
				this.loadFolders();
				this.showUpdateFolder = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewUpdateFolder(): void {
		this.updateFolderModel.Id = this.selectedFolder.data;
		this.updateFolderModel.Color = this.selectedFolder.color;
		this.updateFolderModel.Description = this.selectedFolder.description;
		this.updateFolderModel.Heading = this.selectedFolder.heading;
		this.updateFolderModel.LogoId = this.selectedFolder.logoId;
		this.updateFolderModel.IconId = this.selectedFolder.iconId;
		this.updateFolderModel.Structured = this.selectedFolder.structured;
		this.folderLogo = this.selectedFolder.logo;
		this.folderIcon = this.selectedFolder.icon;
		this.showUpdateFolder = true;
	}

	removeIcon(): void {
		this.folderIcon = null;
		this.updateFolderModel.IconId = null;
		this.uploadingLogo = false;
	}

	removeImage(): void {
		this.folderLogo = null;
		this.updateFolderModel.LogoId = null;
		this.uploadingLogo = false;
	}

	removeColor(): void {
		this.updateFolderModel.Color = null;
	}

	confirmDeleteFolder(): void {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete <strong>${this.selectedFolder.label}</strong>?`
				+ `<p>Deleting the folder will delete all the folders in it and all the files in those folders.</p>`,
			header: 'Delete Confirmation',
			icon: 'fa fa-trash',
			accept: () => {
				this.loading = true;
				this.storageService.deleteDirectory(this.selectedFolder.data).then(
					result => {
						this.selectedFolder = {
							label: '',
							color: '',
							description: '',
							logo: ''
						};
						this.loadFolders();
						this.files = [];
						this.folder = new CreateFolderModel();
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}

	confirmDeleteFile(file: IFile): void {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete <strong>${file.Name}</strong>?`,
			header: 'Delete Confirmation',
			icon: 'fa fa-trash',
			accept: () => {
				this.loading = true;
				this.storageService.deleteFile(file.PublicId).then(
					result => {
						this.loading = false;
						this.getFiles(this.selectedFolder.data);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}

	tagFile(): void {
		this.loading = true;
		this.tag.DocumentId = this.selectedFile.PublicId;
		this.storageService.tagDocument(this.tag).then(
			result => {
				this.selectedFile.Tags.push({ Name: this.tag.Name });
				this.tag.Name = '';
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}


	viewTags(file: IFile): void {
		this.selectedFile = file;
		this.tags = true;
	}

	removeTag(file: IFile): void {
		this.loading = true;
		this.tag.DocumentId = this.selectedFile.PublicId;
		this.tag.Name = file.Name;
		this.storageService.removeTagFromDocument(this.tag).then(
			result => {
				this.selectedFile.Tags.splice(file, 1);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	forIdentify(tagId: number, index: number) {
		return index;
	}

	renameFile(): void {
		this.loading = true;
		this.storageService.renameDocument(this.renameFileModel).then(
			result => {
				this.loading = false;
				let extenstion = this.selectedFile.Name.split(".")[1];
				this.selectedFile.Name = `${this.renameFileModel.Name}.${extenstion}`;
				this.showRenameFile = false;
			},
			error => {
				this.loading = false;
				this.showRenameFile = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewRename(file: IFile): void {
		this.selectedFile = file;
		console.log(file);
		this.renameFileModel.DocumentId = file.PublicId;
		this.renameFileModel.Name = file.Name.split(".")[0];
		this.showRenameFile = true;
	}

	describeFile(): void {
		this.loading = true;
		this.storageService.describeDocument(this.description).then(
			result => {
				this.loading = false;
				this.selectedFile.Description = this.description.Description;
				this.selectedFile.Pages = this.description.Pages;
				this.selectedFile.Orientation = this.description.Orientation;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewDescription(file: IFile): void {
		this.selectedFile = file;
		this.description.DocumentId = file.PublicId;
		this.description.Description = file.Description;
		this.desc = true;
	}

	setFolderToMoveTo(event): void {
		this.selectedMoveFolder = event.node;

	}

	moveFile() {
		this.showMoveFile = false;
		this.confirmationService.confirm({
			message: `Are you sure you want to move <strong>${this.selectedFile.Name}</strong> to the folder <strong>${this.selectedMoveFolder.label}</strong>?`,
			header: 'Move Confirmation',
			icon: 'fa fa-copy',
			accept: () => {
				this.loading = true;
				var model = new MoveDirectoryModel();
				model.Id = this.selectedFile.PublicId;
				model.ParentId = this.selectedFolder.data;
				this.storageService.moveFile(model).then(
					result => {
						this.showMoveFile = false;
						this.loading = false;
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});

	}

	viewMoveFile(file: IFile): void {
		this.selectedFile = file;
		this.showMoveFile = true;
	}

	download(file: IFile) {
		this.selectedFile = file;
		this.downloading = true;
		this.storageService.downloadFile(file.PublicId).subscribe(
			blob => {
				this.downloading = false;
				saveAs(blob, file.Name);
			},
			error => {
				this.downloading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	handleFile(event): void {
		this.uploading = false;
		this.getFiles(this.selectedFolder.data);
	}

	handleError(event): void {
		this.uploading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	handleIcon(event): void {
		var result = this.storageService.handleSuccess(event);
		console.log(result);
		this.folderIcon = result.PublicId;
		this.updateFolderModel.IconId = result.Id;
		this.uploadingLogo = false;
	}

	handleLogo(event): void {
		var result = this.storageService.handleSuccess(event);
		console.log(result);
		this.folderLogo = result.PublicId;
		this.updateFolderModel.LogoId = result.Id;
		this.uploadingLogo = false;
	}

	handleErrorLogo(event): void {
		this.uploadingLogo = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	uploadLink(): void {
		this.uploading = true;
		this.link.DirectoryId = this.selectedFolder.data;
		this.storageService.uploadLink(this.link).then(
			result => {
				this.uploading = false;
				this.files.push(result);
				this.link.Link = '';
			},
			error => {
				this.uploading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	togglePublishedFolder(): void {
		var title = this.selectedFolder.icon === "fa-window-close" ? "Publish" : "Un-Publish";
		this.confirmationService.confirm({
			message: `Are you sure you want to ${title} <strong>${this.selectedFolder.label}</strong>?`,
			header: `${title} Publish Confirmation`,
			icon: 'fa fa-folder-o',
			accept: () => {
				this.loading = true;
				this.storageService.publishDirectory(this.selectedFolder.data).then(
					result => {
						this.selectedFolder = {
							label: '',
							color: '',
							description: '',
							logo: ''
						};
						this.loadFolders();
						this.files = [];
						this.folder = new CreateFolderModel();
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}

	getBackground(folder: TreeNode) {
		var background = {
			'background-image': `url(${this.storageService.downloadUrl}/${(folder as any).logo && this.folderLogo})`,
			'background-size': 'cover',
			'background-repeat': 'no-repeat',
			'background-position': 'center center'
		};
		return background;
	}

	orderFiles(event) {
		this.loading = true;
		let model = new ReorderDirectoryFilesModel();
		model.DirectoryId = this.selectedFolder.data;
		model.Files = this.files.map(x => x.Id);

		this.storageService.reorderDirectoryFiles(model).then(
			result => {
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	@ViewChild('folderPanel') folderPanel: ElementRef;

	getFilePanelStye() {
		//{'height':'500px','width':'100%'}
		//console.log(this.folderPanel.nativeElement.offsetHeight);
		var height = this.folderPanel.nativeElement.offsetHeight - 184;
		//console.log(height);
		return { 'height': height + "px" };
	}


	addObjective(): void {
		this.loading = true;
		this.storageService.addObjective(this.addObjectiveModel).then(
			result => {
				this.loading = false;
				this.addObjectiveModel.Description = "";
				this.getObjectives(this.addObjectiveModel.DirectoryId);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewObjectives(): void {
		this.getObjectives(this.selectedFolder.data);
		this.addObjectiveModel = new AddObjectiveModel();
		this.addObjectiveModel.DirectoryId = this.selectedFolder.data;
		this.showObjectives = true;
	}

	getObjectives(id: number) {
		this.loading = true;
		this.storageService.getObjectives(id).then(
			result => {
				this.objectives = result;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	deleteObjective(obj): void {
		this.loading = true;
		this.storageService.deleteObjective(obj.Id).then(
			result => {
				this.loading = false;
				this.getObjectives(this.addObjectiveModel.DirectoryId);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	sendAllDialogOpen(file: IFile) {
		this.contentId = file.Id;
		this.contentType = NotificationContentType.File;
		this.sendAllDialog = true;
	}

	authorFile(): void {
		this.loading = true;
		if (typeof this.author.LearningCourseId === 'string') {
			this.author.LearningCourseId = +this.author.LearningCourseId;
		}
		this.storageService.updateAuthor(this.author).then(
			result => {
				this.loading = false;
				this.selectedFile.Author = result;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	onCourseChange(courseId: number): void {
		this.author.LearningCourseId = courseId;
	}

	showAuthor = false;

	viewAuthor(file: IFile): void {
		this.selectedFile = file;
		this.author = new AddDocumentAuthor();
		this.author.DocumentId = file.PublicId;
		this.author.Name = file.Author.Name;
		this.author.Description = file.Author.Description;
		this.author.Institute = file.Author.Institute;
		this.author.PictureId = file.Author.PictureId;
		this.author.InstitutePictureId = file.Author.InstitutePictureId;
		this.author.VideoDuration = file.Author.VideoDuration;
		this.author.LearningCourseId = file.Author.LearningCourseId;
		this.author.AttachmentFileId = file.Author.AttachmentFileId;
		this.showAuthor = true;
	}

	coverUpload(): void {
		this.loading = true;
		this.storageService.updateCoverImages(this.selectedFile.PublicId, this.coverImageId, this.featuredImageIds).then(
			result => {
				this.loading = false;
				this.showCoverUploader = false;
				this.error.push({ severity: 'success', summary: 'Success', detail: "Saved Successfully" });

			},
			error => {
				this.loading = false;
				this.error = [];
				this.showCoverUploader = false;
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	flagDesign(): void {
		this.loading = true;
		this.storageService.flagDesign(this.selectedFile.PublicId, this.isDesigned).then(
			result => {
				this.loading = false;
				this.showCoverUploader = false;
				this.error.push({ severity: 'success', summary: 'Success', detail: "Saved Successfully" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.showCoverUploader = false;
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}


	viewUploadCover(file: IFile): void {
		this.selectedFile = file;
		this.showCoverUploader = true;
		this.coverImageId = file.CoverImageId;
		this.isDesigned = this.selectedFile.IsDesigned;
	}
	handleCoverImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.coverImageId = result.PublicId;
		this.uploadingCover = false;
	}
	handleFeaturedImages(event): void {
		var result = this.storageService.handleSuccess(event);
		this.featuredImageIds.push(result.PublicId);
		this.uploadingfeatured = false;
	}

	removeFeaturedImages(imageId: string): void {
		this.featuredImageIds = this.featuredImageIds.filter(x => x != imageId);
	}

	handleAuthor(event, property): void {
		var result = this.storageService.handleSuccess(event);
		this.author[property] = result.PublicId;
		this.uploadingLogo = false;
	}

	plans: SelectItem[];
	selectedPlan;

	initPlanDropDown(event) {
		this.subscriptionService.getDropdown(event).then(
			x => {
				this.plans = x;
				if (this.selectedFile) {
					var filePlans = this.selectedFile.SubscriptionPlans.map(y => y.Id);
					this.plans = this.plans.filter(x => filePlans.indexOf(Number(x.value)) === -1);
				}
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	addPlan(): void {
		this.planModel.PlanIds.push(this.selectedPlan.value);
	}

	removePlan(event, plan) {
		this.planModel.PlanIds = this.planModel.PlanIds.filter(x => x !== event.value.Id);
	}

	setPlans(): void {
		this.loading = true;
		this.storageService.updatePlans(this.planModel).then(
			result => {
				this.loading = false;
				this.selectedFile = result;
				this.selectedPlan = {};
				this.getFiles(result.DirectoryId);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewPlans(file: IFile): void {
		this.selectedFile = file;
		this.planModel = new UpdatePlansModel();
		this.planModel.DocumentId = this.selectedFile.PublicId;
		this.planModel.PlanIds = this.selectedFile.SubscriptionPlans.map(x => x.Id);
		this.showPlans = true;
	}

	selectedInterest;
	addInterests(): void {
		this.loading = true;
		const model = {
			DocumentId: this.selectedFile.PublicId,
			InterestIds: this.interestModel.InterestIds,
		};

		this.storageService.addInterestToDoc(model).then(
			result => {
				this.loading = false;
				this.interest = false;
				this.selectedInterest = "";
				this.selectedInterests = [];
			}, error => {
				this.loading = false;
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		)
	}

	initInterestsDropdown(): void {
		this.storageService.getInterestsList().then(
			x => {
				this.interests = x;
				this.loading = false;

			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	learningCourseDropdown(): void {
		this.storageService.getLearningCourseList().then(
			x => {
				this.learningCourses = x.map(course => ({
					label: course.label,
					value: course.value
				}));
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewInterests(file: IFile): void {
		this.selectedFile = file;
		this.interest = true;
	}

	addInterestToDoc(): void {
		this.interestModel.InterestIds.push(this.selectedInterest.value);
		this.selectedInterests.push(this.selectedInterest);
	}

	removeInterest(interest) {
		this.selectedInterests = this.selectedInterests.filter(i => i !== interest.value);
	}

	onLearningCoursesClick(): void {
		this.showLearningCourses = true;
		this.showCoursePath = false;
		this.loadLearningCourses();
	}

	onCoursePathClick(): void {
		this.showCoursePath = true;
		this.showLearningCourses = false;
		this.loadCoursePath();
	}

	onCourseImageUpload(event): void {
		const result = this.storageService.handleSuccess(event);
		this.newCourse.CourseImageId = result.PublicId;
	}

	onCoursePathImageUpload(event: any, mode: string) {
		const uploadedFile = event.files[0];
		if (uploadedFile && uploadedFile.response) {
			const uploadedId = uploadedFile.response.fileId;
			this.editCourseData.CoverId = uploadedId;
		}
	}

	// addLearningCourse(): void {
	// 	console.log("Adding new course:", this.newCourse);
	// 	this.storageService.addLearningCourse(this.newCourse).then(() => {
	// 		this.loadLearningCourses();
	// 		this.showAddCourseDialog = false;
	// 		this.newCourse = {
	// 			CourseName: '',
	// 			CourseImageId: null,
	// 			Description: '',
	// 			LearningOutcomes: '',
	// 			TargetAudience: '',
	// 			Speakers: '',
	// 			CoursePathId: 0,
	// 			Tags: null
	// 		};

	// 	});
	// }
	addLearningCourse(): void {
  // If no CoursePathId is selected, default to the first one
  if (!this.newCourse.CoursePathId && this.coursePaths.length > 0) {
    this.newCourse.CoursePathId = this.coursePaths[0].PathOrder;
  }

  console.log("Adding new course:", this.newCourse);
  this.storageService.addLearningCourse(this.newCourse)
    .then(() => {
      this.loadLearningCourses();
      this.showAddCourseDialog = false;

      this.newCourse = {
        CourseName: '',
        CourseImageId: null,
        Description: '',
        LearningOutcomes: '',
        TargetAudience: '',
        Speakers: '',
        CoursePathId: undefined,  // reset to undefined
        Tags: ''
      };
    })
    .catch(err => console.error('Error adding course:', err));
}





	addCoursePath(): void {
		this.storageService.addCoursePath(this.newCoursePath)
			.then(() => {
				this.loadCoursePath();
				this.newCoursePath = {
					Id: undefined,
					Name: '',
					Description: '',
					PathOrder: 1,
					CoverId: null,
					Published: false,
					CourseId: null,
					CreatedByUserId: null,
					DateCreatedUtc: null,
					DateUpdatedUtc: null
				};
			})
			.catch(err => console.error('Error adding course path:', err));
	}

	loadLearningCourses(): void {
		this.loading = true;
		this.storageService.getLearningCourseList().then(
			(courses: any[]) => {
				this.learningCoursesInfo = courses;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	editCourse(course: any): void {
		this.editCourseData = {
			id: course.value,
			CourseName: course.label,
			CourseImageId: course.image,
			Description: course.description,
			LearningOutcomes: course.learningOutcomes,
			TargetAudience: course.targetAudience,
			Speakers: course.speakers || '',
			CoursePathId: course.coursePathId || 0,
			Tags: course.tags
		};
		this.showEditCourseDialog = true;
	}

	onEditCourseImageUpload(event): void {
		const result = this.storageService.handleSuccess(event);
		this.editCourseData.CourseImageId = result.PublicId;
	}

	onEditCoursePathImageUpload(event): void {
		const result = this.storageService.handleSuccess(event);
		this.editCourseData.CoverId = result.PublicId;
	}

	submitCourseUpdate(): void {
		this.storageService.updateLearningCourse(this.editCourseData)
			.then(() => {
				this.showEditCourseDialog = false;
				this.loadLearningCourses();
			})
			.catch(() => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: 'Failed to update course.' });
			});
	}



	submitCoursePathUpdate(): void {
		this.storageService.updateCoursePath(this.editCourseData)
			.then(() => {
				this.showEditCoursePathDialog = false;
				this.loadCoursePath();
			})
			.catch(() => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: 'Failed to update course.' });
			});
	}

	deleteCourse(id: number): void {
		if (!id) return;
		this.storageService.deleteLearningCourse(id).then(() => {
			this.loadLearningCourses();
		}).catch(() => {
			this.error = [];
			this.error.push({ severity: 'error', summary: 'Error', detail: 'Failed to delete course.' });
		});
	}
	deleteCoursePath(id: number): void {
		if (!id) return;
		this.storageService.deleteCoursePath(id).then(() => {
			this.loadCoursePath();
		}).catch(() => {
			this.error = [];
			this.error.push({ severity: 'error', summary: 'Error', detail: 'Failed to delete course.' });
		});
	}
	editCoursePath(course: any): void {
		this.showEditCoursePathDialog = true;
		console.log("Editing course path:", course);

		this.editCourseData = {
			Id: course.Id,
			Name: course.Name,
			Description: course.Description,
			PathOrder: course.PathOrder,
			CoverId: course.CoverId,
			Published: course.Published,
			CourseId: course.CourseId,
			CreatedByUserId: course.CreatedByUserId,
			DateCreatedUtc: course.DateCreatedUtc,
			DateUpdatedUtc: course.DateUpdatedUtc
		};
	}
	onAuthorAttachmentUpload(event): void {
		const result = this.storageService.handleSuccess(event);
		this.author.AttachmentFileId = result.PublicId;
	}


	tagCourse() {
		if (!this.selectedCourse.id) {
			alert('Please save the course before adding tags.');
			return;
		}

		if (!this.selectedCourse.Tags.some(t => t.Name === this.courseTag.Name)) {
			this.selectedCourse.Tags.push({ Name: this.courseTag.Name });
			this.saveTagsToDatabase();
		}

		this.courseTag = { Name: '' };
	}


	removeCourseTag(tag: any) {
		this.selectedCourse.Tags = this.selectedCourse.Tags.filter(t => t !== tag);
		this.saveTagsToDatabase();
	}

	saveTagsToDatabase() {
		const tagsArray = this.selectedCourse.Tags.map(t => t.Name);
		const updatedCourse = {
			...this.selectedCourse,
			Tags: JSON.stringify(tagsArray)
		};

		this.storageService.updateLearningCourse(updatedCourse)
			.then(() => {
				console.log('Tags updated successfully');
			})
			.catch(() => {
				console.error('Failed to update tags');
			});
	}





}



// WEBPACK FOOTER //
// ./src/app/components/content/upload/upload.component.ts